import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import template from './sql-console.hbs'
import BusyButton from 'scoreboard/components/busy-button'
import SqlConsoleResults from 'scoreboard/components/sql-console/sql-console-results'
import i18n from 'scoreboard/components/i18n'
import HttpStatusCodes from 'http-status-codes'
import formatValue from 'scoreboard/components/format-value'
import DisplayHeader from 'scoreboard/components/display-header'
import sendToExcelToolip from 'scoreboard/components/export/send-to-excel-tooltip'
import reportConstants from 'scoreboard/reports/report-constants'
import user from 'scoreboard/components/user'
import SqlEditor from 'scoreboard/components/sql-console/sql-editor'
import HistoryManager from 'scoreboard/components/sql-console/sql-history-manager'
import setupErrors from 'scoreboard/components/setup-errors'

/* A version of the sql console that combines the query form and results into
 * a single view
 */
var SqlConsole = SqlConsoleResults.extend({

	className: 'admin sql-console display-layout table-hack form',

	events: {
		'click .button-primary': 'onRun',
		'click .clear': 'clear',
		'click .export' : 'sendTo'
	},

	_template: function(ctx) {
		return template(ctx)
	},

	render: function() {
		this.resultsButton && this.resultsButton.remove()
		if (this.isSelect) {
			SqlConsoleResults.prototype.render.apply(this, arguments)
			this.$('.export-button').removeClass('is-not-displayed')
			if (user.isBuiltInAdmin()) {
				this.renderMaxResultsWarning(reportConstants.MAX_RESULTS_ADMIN)
			} else {
				this.renderMaxResultsWarning(reportConstants.MAX_RESULTS)
			}
		} else {
			this.renderUpdateResults(this.model.initialData)
		}
		this.resultsButton = new BusyButton({el: this.$('.button-primary')})
		if (!this.sqlHistoryManager) {
			this.sqlHistoryManager = new HistoryManager(this.model.get('query'))
		}
		this.queryTextarea = new SqlEditor({
			el: this.$('textarea.query'),
			onExecute: this.loadResults.bind(this),
			manager: this.sqlHistoryManager
		}).render()
		this.queryTextarea.on('change', query => {
			this.model.set('query', query)
		})

		// Insert the display header to provide menu navigation when we enter the mobile width
		this.$('.display-pane-body').before(new DisplayHeader({
			heading: i18n.get('report.sqlConsole.title'),
			mobileGearHidden: true
		}).render().el)
		return this
	},

	renderMaxResultsWarning: function(maxResults) {
		const metadata = this.model.metadata
		if (metadata && metadata.numResults >= maxResults) {
			let msg = i18n.get('report.sqlConsole.query.warn.maxResults',
				formatValue({value: maxResults, shorten: false}))
			this.$('.banner')
				.removeClass('is-not-displayed banner-error')
				.addClass('banner-warning')
				.html(`<div>${msg}</div>`)
		}
	},

	renderUpdateResults : function(data) {
		this.$el.empty().append(this._template())

		this.resultsDisplayed = this.$('.sql-results-container')
		this.panelHeader = this.$('.panel-header')
		this.tableBody = this.$('tbody')
		this.tableHead = this.$('thead')
		this.bannerError = this.$('.sql-banner-error')

		var metadata = this.model.metadata
		if (metadata && metadata.error) {
			return this.renderError(metadata.error)
		}

		this.$('.export-button').addClass('is-not-displayed')
		this.resultsDisplayed.addClass('is-not-displayed')
		if (!_.isEmpty(data)) {
			var numRows = data[0].value
			var updateResultsData = i18n.get('admin.consoles.numberRowsAffected.duration',
				_.escape(formatValue({ value: numRows || 0 })),
				_.escape(metadata.duration))
			this.$('.banner-update-results')
				.removeClass('is-not-displayed')
				.html(updateResultsData)
		}
	},

	onRun: function() {
		this.queryTextarea.execute()
	},

	loadResults: function(query) {
		if (this.resultsButton.state == 'disabled') return

		this.model.set('query', query)

		if (query) {
			this.lastQuery = this.queryTextarea.getVal()
			this.$('.panel-content').addClass('is-submitting-form') // Add class manually since formView isn't used here
			this.resultsButton.loading()
			this.isSelect = _.startsWith(query.toLowerCase(), 'select')
			this.model.set('run', true, {silent: true})
			this.model.fetch({
				script: this.lastQuery,
				error: function(model, xhr) {
					this._renderOnError = true
					var err = i18n.get('common.error.unknown')
					// #54712 for 403 errors use the standard error handler
					// (Note that this was previously used to handle attempts
					// to run a non-select query by a non-admin user, and display
					// a message on the page but that case seems to now be
					// handled by adding the error to the report results metadata
					// and re-rendering the page with the error message)
					if (xhr.status == HttpStatusCodes.FORBIDDEN) {
						// don't re-render the page
						this._renderOnError = false
						// use setupErrors to display the no permissions page
						setupErrors.errorHandler(xhr)
					}
					model.metadata = {error: err}
				}.bind(this)
			}).then(this.render.bind(this), () => {
				if (this._renderOnError) {
					///only render if we're processed the custom error handler above
					delete this._renderOnError
					this.render()
				}
			})
		} else {
			this.renderError(i18n.get('common.error.required', i18n.get('report.sqlConosle.query')))
		}
	},

	clear: function(e) {
		this.$('.query').val('').trigger('input')
		this.resultsDisplayed.addClass('is-not-displayed')
		this.resultsDisplayed.find('h3').empty()
		this.$('.export-button').addClass('is-not-displayed')
		this.$el.removeClass('has-error')
		this.$('.banner-update-results').empty().addClass('is-not-displayed')
		_.invokeMap([this.tableCaption, this.tableHead, this.tableBody], 'empty')
		this.queryTextarea.focus()
		delete this._keys
	},

	sendTo: function(e) {
		const target = $(e.currentTarget)
		const heading = this.$('h1').text()
		this.sendToTooltip = sendToExcelToolip(target, heading, {
			csvDownloadFn: () => this.exportTable()
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.resultsButton, this.sendToTooltip,
			this.queryTexarea], 'remove')
	}

})

export default SqlConsole

SqlConsole.__filename__ = 'admin/sql-console.js'
